import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export const capsuleVariants = cva(
  twMerge([
    'rounded-full',
    'w-max',
    'h-auto',
    'py-2',
    'px-3',
    'font-medium',
    'text-xs',
    'cursor-default',
    'flex',
    'flex-row',
    'items-center',
    'justify-center',
    'gap-1',
    'font-sans'
  ]),
  {
    variants: {
      variant: {
        pending: 'bg-blue-100 text-emerge-navy',
        completed: 'bg-emerge-teal-3 text-dark-teal-30',
        declined: 'bg-emerge-orange-3 text-error-darkred',
        input: 'bg-emerge-navy-4 text-dark-navy-30'
      }
    }
  }
);
